// Module: Scrollbar
// 

JLM.MD.Scrollbar = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Properties: Private ______________________________________________________
	
	// References
	let bar;
	
	// Settings
	let init_y = 0,
		offset_y = 0,
		is_dragging = false,
		min_y, max_y;
	
	
	
	// Properties: Public _______________________________________________________
	
	INSTANCE.scroll_position = 0;
	INSTANCE.scroll_percent = 0;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		bar = $('div', container);
		
		// Settings
		min_y = 0;
		max_y = container.height() - bar.height();
		
		// Events
		bar.on('mousedown', startDragging);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Dragging: Start
	// 
	function startDragging(event) {
		min_y = 0;
		max_y = container.height() - bar.height();
		init_y = event.clientY - offset_y;
		$(document).on('mouseup', stopDragging).on('mousemove', whileDragging);
		INSTANCE.dispatchEvent('drag_start');
		event.preventDefault();
	}
	
	
	// Dragging: While
	// 
	function whileDragging(event) {
		is_dragging = true;
		bar.addClass('dragging');
		
		setPosition(event.clientY - init_y);
		bar.css({ transform: 'translate3d(0,' + INSTANCE.scroll_position + 'px,0)' });
		
		INSTANCE.dispatchEvent('dragging', [ INSTANCE.scroll_position, INSTANCE.scroll_percent ]);
		event.preventDefault();
	}
	
	
	// Dragging: Stop
	// 
	function stopDragging(event) {
		is_dragging = false;
		bar.removeClass('dragging');
		init_y = INSTANCE.scroll_position;
		$(document).off('mouseup', stopDragging).off('mousemove', whileDragging);
		INSTANCE.dispatchEvent('drag_stop');
	}
	
	
	// Keep position within bounds
	// 
	function setPosition( position ) {
		position = Math.max(min_y, position);
		position = Math.min(max_y, position);
		offset_y = position;
		INSTANCE.scroll_position = position;
		INSTANCE.scroll_percent = INSTANCE.scroll_position / max_y;
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Set percent externally
	// 
	INSTANCE.setPercent = function(percent) {
		if ( !is_dragging ) {
			bar.addClass('reposition');
			setPosition(percent * max_y);
			bar.css({ transform: 'translate3d(0,' + INSTANCE.scroll_position + 'px,0)' });
			setTimeout(function() {
				bar.removeClass('reposition');
			}, 800);
		}
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};